<template>
  <v-container>

    <v-row justify="center">
      <v-col cols="12" md="6">
        <div class="headline">
          Total Payments: ${{totalPayments}}
        </div>
        <!-- <div class="headline">
          Commissions Payments: ${{userProfile.comPaymentsTotal}}
        </div> -->
        <v-row>
          <v-col cols="12">

          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <div v-if="customerPayments.length !== 0">
          <template>
            <payout-list-item :key="item._key" v-for="item in customerPayments" :transaction="item" ></payout-list-item>
          </template>
        </div>
        <v-row v-else>
          <v-col cols="12" align="center">
            <div >{{ $language.transactions['There are no transactions at the moment'] }}.</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show" :color="snackbar.status === 'error' ? 'error' : 'success'" multi-line :timeout="1500">
      {{ snackbar.message }}

    </v-snackbar>

  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import PayoutListItem from '@/components/jefe/payouts/PayoutListItem'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    PayoutListItem
  },
  data () {
    return {

      show: false,
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      }
    }
  },
  created () {
    this.$store.dispatch('fetchCustomerPayments')
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'customerPayments', 'userJobs']),
    totalPayments () {
      if (this.customerPayments) {
        var tot = Object.values(this.customerPayments).reduce((a, c) => {
          return parseFloat(c.paymentAmount) + a
        }, 0)
        return tot.toFixed(2)
      }
      return null
    }
  },
  methods: {
    createLink () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/getNewURL`] = new Date()
      fb.database.ref().update(updates)
    },
    openJob (item) {
      this.$router.push('/dashboard')
      this.$nextTick(() => {
        this.$store.dispatch('openJobDialog', {
          job: item,
          tab: 'Payouts'
        })
      })
    }
  },
  watch: {},
  filters: {
    formatMonth (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      // There's most definitely a more elegant way of doing this.
      return moment(date).format('MMMM')
    },
    formatDay (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      // There's most definitely a more elegant way of doing this.
      return moment(date).format('D')
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 10) {
        return val
      }
      return `${val.substring(0, 10)}...`
    }
  }
}

</script>
